/// <amd-module name="Environments/EnvironmentTraceabilityWorkItems/Actions/WorkitemsActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { IWorkitemsResult } from "Environments/Client/EnvironmentContracts";
import { WorkItemType } from "Environments/RemoteClients/Contracts/WorkItemTracking";

export class WorkitemsActions extends ActionsHubBase {

    public static getKey(): string {
        return "workitems-actions";
    }

    public initialize(instanceId?: string) {
        this._setWorkitems = new Action<IWorkitemsResult>();
        this._setIcons = new Action<WorkItemType[]>();
    }

    public get setWorkitems(): Action<IWorkitemsResult> {
        return this._setWorkitems;
    }

    public get setIcons(): Action<WorkItemType[]> {
        return this._setIcons;
    }

    private _setWorkitems: Action<IWorkitemsResult>;
    private _setIcons: Action<WorkItemType[]>;
}
